import { sharedBackendErrorMap } from "./shared";

export * from "./shared";

/**
 * Web/electron half — web’s wording for the 5 genuinely divergent codes.
 *
 * Only the 5 codes that exist on BOTH platforms with DIFFERENT wording are listed here; every
 * other code comes from `sharedBackendErrorMap`. Spread order matters — these override.
 *
 * The side-by-side comparison of the two wordings lives in shared.ts ONLY. Do not repeat the
 * other platform’s strings here: the dev bundle keeps comments, so a symbol-level grep of the
 * Metro bundle would report them as a resolution leak that is not real (ledger, session 8).
 */
export const backendErrorMap = {
  ...sharedBackendErrorMap,
  "REST_INVALID_USER": "Your account is locked due to multiple failed attempts. Please reset your password or contact your manager/admin or Rista support.",
  "REST_INVALID_COUPON": "Invalid coupon or wrong number",
  "UI_ERR_INVALID_LOGIN_PARAMS": "Incorrect Pin.",
  "UI_ERR_OFFLINE_PASSWORD_NOT_FOUND": "Offline password not found for user.",
  "REST_SALE_WITH_STALE_CATALOG": "Amount mismatch. You might have a stale catalog. Please logout and login to refresh.",
};
